// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import Typography from '@mui/material/Typography';
import SeleccionarAlias from './seleccionar-alias/SeleccionarAlias';
import RedactarMail from './redactar-mail/RedactarMail';
import Verificacion from './verificacion/Verificacion';
import { CloseButton } from "../../../Componentes/feedback/dialog/CloseButton";
import { Button, CircularProgress, Skeleton, useMediaQuery } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import axios from 'axios';
import { useDifusiones } from '../../context/DifusionesContext';
import { RUTA_API_DIFUSIONES } from '../../../Contantes/Constantes';
import { useBody } from '../../../Body/state/BodyContext';
import StepButton from '@mui/material/StepButton';

export default function AgregarDifusion({ onClose }) {
  const { areasUser, obtenerAlias } = useDifusiones();
  const { setMessage } = useBody();

  const [form, setForm] = useState({
    alias: undefined,
    aliasNombre: undefined,
    area: undefined,
    asunto: "",
    firma: undefined,
    area_nombre: undefined,
    replyTo: "",
    listasSeleccionadas: [],
    listasNoSeleccionadas: [],
    adjuntos: [],
    fechaProgramada: null,
  });

  const [bodyHtml, setBodyHtml] = useState("");
  const [newBodyHtml, setNewBodyHtml] = useState("");
  const [alias, setAlias] = useState([]);
  const [images, setImages] = useState([]);
  const [noReplysMails, setNoReplysMails] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [direccion, setDireccion] = useState('left');
  const [alertSecondStep, setAlertSecondStep] = useState(null);
  const [alertFirstStep, setAlertFirstStep] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingListas, setLoadingListas] = useState(false);
  const [aliasLimitadas, setAliasLimitadas] = useState([]);
  const matches = useMediaQuery('(max-width:960px)');
  const isSm = useMediaQuery('(max-width:600px)');

  const steps = matches ? ["", "", ""] : ['Seleccionar Remitente', 'Redactar Difusión', 'Verificar Datos'];

  const generarUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };

  // La dirección no-reply la define soporte por área y viaja como atributo del grupo de
  // Keycloak. Las áreas que todavía no la tienen cargada conservan la dirección derivada
  // del nombre del área.
  const noReplysConfigurados = (area) =>
    (area.attributes?.noReply ?? []).map(d => d.trim()).filter(Boolean);

  // Un área sin direcciones cargadas conserva la derivada de su nombre, para no dejarla sin
  // remitente hasta que soporte la complete.
  const noReplysDeArea = (area) => {
    const configurados = noReplysConfigurados(area);
    if (configurados.length) return configurados;
    return [`no-reply-${area.name.toLowerCase().replace(/\s+/g, '')}@frba.utn.edu.ar`];
  };

  const alistarCuerpoHtml = (images, bodyHtml, firma) => {
    let nuevoBodyHtml = bodyHtml;
    images.forEach(image => {
      if (nuevoBodyHtml.includes(image.base64)) {
        const uid = generarUUID();
        nuevoBodyHtml = nuevoBodyHtml.replaceAll(image.base64, uid);
        Object.assign(image, { uid });
      }
    });
    if (firma?.firmaHtml) {
      nuevoBodyHtml += "<br/>---<br/>" + firma.firmaHtml;
    }
    return nuevoBodyHtml;
  };

  const validarForm = () => {
    if (form.listasSeleccionadas.length < 1)
      return { status: 'error', message: 'Es obligatorio ingresar al menos una lista destinataria.' };
    if (form.asunto.length < 3 || 255 < form.asunto.length)
      return { status: 'error', message: 'El asunto debe tener entre 3 y 255 caracteres' };
    if (form.adjuntos.length < 1 && bodyHtml == "")
      return { status: 'error', message: 'No se ha introducido ni un mensaje ni un archivo. Al menos uno de estos campos es obligatorio.' };
    return null;
  };

  useEffect(() => {
    const fetchAlias = async () => {
      setLoading(true);
      try {
        const resAlias = await obtenerAlias();
        const aliasData = resAlias || [];

        if (areasUser?.length) {
          setNoReplysMails(areasUser.flatMap(area =>
            noReplysDeArea(area).map(email => ({ id: `${area.id}|${email}`, areaId: area.id, email }))
          ));
        }

        setAlias(aliasData);
      } catch (error) {
        console.error("Error al obtener alias:", error);
        setMessage('Error al obtener los alias');
      } finally {
        setLoading(false);
      }
    }

    fetchAlias();
  }, []);

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleNext = (step) => {
    if (step === 1) {
      setNewBodyHtml(alistarCuerpoHtml(images, bodyHtml, form.firma));
    }
    setDireccion('left');
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setDireccion('right');
    setActiveStep((prev) => prev - 1);
  };


  const pages = [
    ...([
      <SeleccionarAlias
        form={form}
        setForm={setForm}
        alias={alias}
        noReplysMails={noReplysMails}
        areasUser={areasUser}
        direccion={direccion}
        alert={alertFirstStep}
        setAlert={setAlertFirstStep}
        setAliasLimitadas={setAliasLimitadas}
      />
    ]),
    <RedactarMail
      form={form}
      setForm={setForm}
      images={images}
      setImages={setImages}
      direccion={direccion}
      alert={alertSecondStep}
      bodyHtml={bodyHtml}
      setBodyHtml={setBodyHtml}
      setAlert={setAlertSecondStep}
      onLoadingChange={setLoadingListas}
    />,
    <Verificacion
      form={form}
      setForm={setForm}
      newBodyHtml={newBodyHtml}
      direccion={direccion}
      onClose={onClose}
      bodyHtml={bodyHtml}
      setBodyHtml={setBodyHtml}
      images={images}
      setImages={setImages}
      aliasLimitado={aliasLimitadas.includes(form.alias)}
      onBack={handleBack}
    />
  ];

  return (
    <Box>
      <CloseButton onClose={onClose} />

      {loading ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="rectangular" height={2} sx={{ flex: 1 }} />
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="rectangular" height={2} sx={{ flex: 1 }} />
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
          <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, width: '60%' }} />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Skeleton variant="rectangular" width={110} height={36} sx={{ borderRadius: 1 }} />
          </Box>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Stepper
            activeStep={activeStep}
            sx={{
              "& .MuiStepIcon-root.Mui-active": {
                color: "#B71234",
              },
              "& .MuiStepIcon-root.Mui-completed": {
                color: "#4caf50",
              },
            }}
          >
            {steps.map((label, index) => (
              <Step key={index}>
                <StepButton color="inherit" onClick={handleStep(index)}>
                  {label}
                </StepButton>
              </Step>
            ))}
          </Stepper>

          <Box>
            {pages[activeStep]}
          </Box>

          {activeStep < pages.length - 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {activeStep > 0 ? (
                <Button variant="outlined" onClick={handleBack} sx={{ textTransform: 'none' }} startIcon={<ArrowBackIcon />}>
                  {!isSm && 'Volver'}
                </Button>
              ) : (
                <Box />
              )}
              <Button
                color="primary"
                disabled={
                  (activeStep === 0 && !form.alias) ||
                  (activeStep === 1 && (
                    loadingListas ||
                    form.listasSeleccionadas.length < 1 ||
                    form.asunto.length < 3 ||
                    form.asunto.length > 255 ||
                    (form.adjuntos.length < 1 && bodyHtml === "")
                  ))
                }
                onClick={() => handleNext(activeStep)}
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                sx={{ textTransform: 'none' }}
              >
                Continuar
              </Button>
            </Box>
          )}

        </Box>
      )}
    </Box>
  );
}
